import extraArgument from "./thunk";
import { ApolloClientType } from "../types/apollo";

const attachClientToStore = (apolloClient: ApolloClientType) => {
  Object.assign(extraArgument, { apolloClient });
};

export default attachClientToStore;
